import React, { useEffect } from 'react';
import { ItemMenuOperationsContent } from './orders/item-menu-operations-content';
import { TagPrintingBluetoothPermissions } from './tag-printing-bluetooth-permissions';
import { useBluetoothContext } from '@/contexts/bluetooth-context';

interface TagPrintingSummaryV2Props {
  goBack: () => void;
  goForward: () => void;
}

export const TagPrintingSummaryV2: React.FC<TagPrintingSummaryV2Props> = ({
  goBack,
  goForward,
}) => {
  const { hasPermission } = useBluetoothContext();

  useEffect(() => {
    if (hasPermission) {
      goForward();
    }
  }, [goForward, hasPermission]);

  return hasPermission ? null : (
    <ItemMenuOperationsContent
      centerTitle
      hideCloseButton
      onClose={() => {}}
      operationName="bluetooth_permissions.title"
    >
      <TagPrintingBluetoothPermissions goBack={goBack} />
    </ItemMenuOperationsContent>
  );
};
